import * as React from 'react';
import { connect } from 'react-redux';

import { PortalTextCommon, PortalTextImportModals } from '../../Models/Api/strongbox.financialportal';
import { ApplicationState } from '../../Store';
import { GetPortalText } from '../../Store/PortalAssets';

import { Overlay } from '../Overlay/Overlay';
import { AlertModal } from '../design-system/components';
import '../ImportCustomerFinancials/NewConnectionModal.scss';

type InjectedReduxState = {
    commonText: PortalTextCommon | undefined;
    importModalsText: PortalTextImportModals | undefined;
};

type InjectedActionCreators = {};

type DiscardProgressModalProps = {
    // Dismiss the confirmation and keep the user where they were.
    onKeepEditing: () => void;
    // Confirm discarding: abort the flow / close the underlying modal.
    onDiscard: () => void;
};

type Props = DiscardProgressModalProps & InjectedReduxState & InjectedActionCreators;

// "Discard progress?" confirmation shown when the user cancels partway through the new-data-collection flow.
// Rendered on top of the modal it is confirming (a second Overlay, so it stacks above).
const DiscardProgressModalComponent: React.FC<Props> = (props): React.ReactElement => {
    const { commonText, importModalsText, onKeepEditing, onDiscard } = props;

    return (
        <Overlay>
            <AlertModal
                title={importModalsText?.discardProgressTitle || 'Discard progress?'}
                onClose={onKeepEditing}
                cancelLabel={commonText?.cancel || 'Cancel'}
                onCancel={onKeepEditing}
                actionLabel={importModalsText?.discardProgressConfirm || 'Discard'}
                actionType={'danger'}
                onAction={onDiscard}
            >
                <p className={'page-body-text'}>{importModalsText?.discardProgressMessage || ''}</p>
            </AlertModal>
        </Overlay>
    );
};

export const DiscardProgressModal = connect<InjectedReduxState, InjectedActionCreators, DiscardProgressModalProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            commonText: GetPortalText<PortalTextCommon>(appState, 'commonText'),
            importModalsText: GetPortalText<PortalTextImportModals>(appState, 'importModals'),
        };
        return result;
    }
)(DiscardProgressModalComponent);
